/* ============================================
   语言切换器 Language Switcher
   ============================================ */
document.addEventListener('DOMContentLoaded', function () {
  var selectors = document.querySelectorAll('.header-language-switcher .localization-selector');
  if (!selectors.length) return;

  selectors.forEach(function (button) {
    var list = button.nextElementSibling;
    if (!list) return;

    // 点击按钮：显示/隐藏下拉
    button.addEventListener('click', function (event) {
      event.stopPropagation();

      // 先关闭其他已经打开的下拉
      document.querySelectorAll('.header-language-switcher .disclosure__list').forEach(function (otherList) {
        if (otherList !== list) otherList.hidden = true;
      });
      document.querySelectorAll('.header-language-switcher .localization-selector').forEach(function (otherBtn) {
        if (otherBtn !== button) otherBtn.setAttribute('aria-expanded', 'false');
      });

      list.hidden = !list.hidden;
      button.setAttribute('aria-expanded', list.hidden ? 'false' : 'true');
    });

    // 点击语言选项：提交表单
    list.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var form = button.closest('form');
        if (!form) return;
        var input = form.querySelector('input[name="language_code"]');
        if (input) {
          input.value = link.getAttribute('data-value');
          form.submit();
        }
      });
    });
  });

  // 点击页面其他地方，关闭所有下拉
  document.addEventListener('click', function () {
    document.querySelectorAll('.header-language-switcher .disclosure__list').forEach(function (list) {
      list.hidden = true;
    });
    document.querySelectorAll('.header-language-switcher .localization-selector').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  });
});